import { useEffect, useState } from "react";
import { useLanguage } from "../tools/LanguageContext";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function NewResult() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [formData, setFormData] = useState({
    match: "",
    date: new Date(),
    time: "12:00",
    prediction: "",
    odds: "",
    units: "1",
    resultHome: "0",
    resultAway: "0",
    won: false,
  });

  useEffect(() => {
    const fetchAdminStatus = async () => {
      if (!token) {
        navigate("/");
      }

      try {
        const response = await axios.get("https://artofbetting.gr/api/get_admin_status", {
          headers: {
            "Authorization": token,
          }
        });
        if (!response.data.admin_status) {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching admin status:", error);
        navigate("/");
      }
    };

    fetchAdminStatus();
  }, [token, navigate]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData({
      ...formData,
      [name]:
        type === "checkbox" ? checked :
        type === "number" ? parseFloat(value) || null :
        value,
    });
  };

  const handleDateChange = (date) => {
    setFormData({ ...formData, date });
  };

  const handleTimeChange = (time) => {
    setFormData({ ...formData, time });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedData = {
        ...formData,
        date: formData.date.toISOString().split('T')[0],
        time: formData.time,
        odds: parseFloat(formData.odds),
        units: parseFloat(formData.units),
        resultHome: parseInt(formData.resultHome, 10),
        resultAway: parseInt(formData.resultAway, 10),
        won: Boolean(formData.won)
    };

    try {
        const response = await axios.post("https://artofbetting.gr/api/add_result", formattedData , {
          headers: {
            "Authorization": token,
          }
        });
        console.log("Success:", response.data);
        alert("Προστέθηκε επιτυχώς το αποτέλεσμα!");
        navigate("/statistics");
    } catch (error) {
        console.error("Axios Error:", error.response ? error.response.data : error);
        alert("Κάτι πήγε στραβά, δοκίμασε πάλι!");
    }
};

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4">
      <header className="flex justify-between items-center p-4 bg-gray-800 mb-6 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
            <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
              {translations.home}
            </button>
          </Link>
        </nav>
      </header>

      <h2 className="text-3xl font-bold mb-4">{translations.newResult}</h2>

      <div className="bg-gray-800 text-white p-6 shadow-md rounded-lg">
        <form onSubmit={handleSubmit} className="grid gap-4">

          {/* Match */}
          <input
            type="text"
            name="match"
            value={formData.match}
            onChange={handleChange}
            placeholder={translations.match}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            required
          />

          {/* Date */}
          <DatePicker
            selected={formData.date}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
          />

          {/* Time */}
          <TimePicker
            onChange={handleTimeChange}
            value={formData.time}
            disableClock={true}
            format="HH:mm"
            className="w-full px-3 py-2 rounded bg-gray-700 text-white border-none"
          />

          {/* Prediction */}
          <input
            type="text"
            name="prediction"
            value={formData.prediction}
            onChange={handleChange}
            placeholder={translations.prediction}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            required
          />

          {/* Odds (Float) */}
          <input
            type="number"
            name="odds"
            value={formData.odds}
            onChange={handleChange}
            placeholder={translations.odds}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            step="0.01"
            required
          />

          {/* Units (Float) */}
          <input
            type="number"
            name="units"
            value={formData.units}
            onChange={handleChange}
            placeholder={translations.units}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            step="0.25"
            required
          />

          {/* Result */}
          <div className="flex items-center space-x-2">
            <span>{translations.result}</span>
            <input
              type="number"
              name="resultHome"
              value={formData.resultHome}
              onChange={handleChange}
              placeholder="0"
              className="w-14 px-3 py-2 rounded bg-gray-700 text-white text-center"
              min="0"
              required
            />
            <span>-</span>
            <input
              type="number"
              name="resultAway"
              value={formData.resultAway}
              onChange={handleChange}
              placeholder="0"
              className="w-14 px-3 py-2 rounded bg-gray-700 text-white text-center"
              min="0"
              required
            />
          </div>

          {/* Won (Checkbox) */}
          <div className="flex items-center space-x-2">
            <span>{translations.won}</span>
            <input
              type="checkbox"
              name="won"
              checked={formData.won}
              onChange={handleChange}
              className="w-5 h-5"
            />
          </div>

          {/* Submit Button */}
          <button type="submit" className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
            {translations.submit}
          </button>
        </form>
      </div>
    </div>
  );
}
